import { createPortal } from 'react-dom'
import styles from './PDFDownloadBtn.module.less'
import { useContext, useRef, useState } from 'react'
import PDFBox from './PDFBox/PDFBox'
import { useReactToPrint } from 'react-to-print'
import { MessageContext } from '@/Contexts/Contexts'
import { useTranslation } from 'react-i18next'
import NiceModal from '@ebay/nice-modal-react'
import DownloadPptRechargeModal from '../Modals/DownloadPptRechargeModal/DownloadPptRechargeModal'
// import html2pdf from 'html2pdf.js'

interface Props {
  as: (p: { loading: boolean }) => React.ReactNode
  project: ProjectModels.ProjectDetail
  debug?: boolean
  hasTranslated?: boolean
}

function PDFDownloadBtn({ as, project, debug = false, hasTranslated }: Props) {
  const { t } = useTranslation()
  const { message } = useContext(MessageContext)

  const [startDownload, setStartDownload] = useState(false)
  const pdfBoxRef = useRef<HTMLDivElement>(null)

  const [loading, setLoading] = useState(false)
  const startPrint = useReactToPrint({
    documentTitle: project.adName,
    contentRef: pdfBoxRef,
    onAfterPrint: () => {
      message.destroy()
      setLoading(false)
      setStartDownload(false)
    },
  })

  const handleDownload = () => {
    if (project.isFreeTrial) {
      NiceModal.show(DownloadPptRechargeModal)
      return
    }

    if (project.status !== 'completed') {
      return
    }
    if (debug) {
      setStartDownload(true)
      message.warning('当前处于 debug 默认，仅能调试 html ，不进行打印')
      return
    }
    if (!hasTranslated) {
      message.warning(t('dashboard.pdf.pdfProcessingDesc2'))
      return
    }
    if (loading) {
      return
    }
    setLoading(true)
    // message.loading(t('dashboard.pdf.pdfProcessing'))
    setStartDownload(true)
  }

  const handleProgress = (progress: number, total: number) => {
    if (debug) {
      return
    }
    // console.log('--->', progress, total)
    if (progress === 1) {
      message.destroy()
      message.loading(
        t('dashboard.pdf.pdfProcessingDesc', { count: total, seconds: Math.ceil(total * 0.5) }),
        0
      )
      /** 这里加个延时，确保 chart 和 img 都加载完成 */
      setTimeout(() => {
        // console.log('start print')
        startPrint()
      }, 3500)
    }
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span className={styles.pdfDownloadBtn} onClick={handleDownload} data-testid='pdf-download-btn'>
          {as({ loading })}
        </span>
      </div>
      {startDownload &&
        createPortal(
          <PDFBox ref={pdfBoxRef} project={project} debug={debug} onProgress={handleProgress} />,
          document.body
        )}
    </>
  )
}

export default PDFDownloadBtn
